import React, { Component } from "react";
import format from "number-formatter";
import { Table } from "reactstrap";
import { connect } from "react-redux";


class PurchaseSummary extends Component {
  render() {
    const {
      selectedOperatorList,
      operatorTokensToBePurchased,
      countryProperties
    } = this.props;



    const totalAmount = operatorTokensToBePurchased[0]?.units * operatorTokensToBePurchased[0]?.amount;
    

    const passengers =
      operatorTokensToBePurchased[0]?.passengers?.length > 0
        ? operatorTokensToBePurchased[0].passengers
        : [];

    return (
      
      <>
      {/* Passenger Summary Table */}
      {passengers?.length > 0 && (
          <div style={{width:"99%",overflow:"auto"}} >
            <h5 className="mt-4 mb-2">Passenger Details</h5>
            <Table bordered>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Gender</th>
                  <th>Phone</th>
                  <th>Next of Kin Name</th>
                  <th>Next of Kin Phone</th>
                </tr>
              </thead>
              <tbody>
                {passengers.map((p, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{p.passengerName}</td>
                    <td>{p.passengerGender}</td>
                    <td>{p.passengerPhoneNumber}</td>
                    <td>{p.passengerNextOfKinName}</td>
                    <td>{p.passengerNextOfKinPhoneNumber}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
        {/* Purchase Summary Table */}
        <Table borderless>
          <tbody>
            <tr>
              <td>Operator:</td>
              <th scope="row" className="text-right">
                <strong>{selectedOperatorList[0]?.operator?.name}</strong>
              </th>
            </tr>
            <tr>
              <td>Route:</td>
              <th scope="row" className="text-right">
                <strong>{operatorTokensToBePurchased[0]?.selectedRoutes}</strong>
              </th>
            </tr>
            <tr>
              <td>Amount Per Unit:</td>
              <th scope="row" className="text-right">
                <strong> {operatorTokensToBePurchased[0]?.amount ? new Intl.NumberFormat(countryProperties.locale, { style: "currency", currency: countryProperties.currency_code }).format(operatorTokensToBePurchased[0]?.amount) : null}</strong>
              </th>
            </tr>
            <tr style={{ borderBottom: "1px solid #D8D8D8" }}>
              <td>Total Unit:</td>
              <th className="text-right">{operatorTokensToBePurchased[0]?.units}</th>
            </tr>
          </tbody>
          <tfoot>
            <tr className="text-right">
              <td>&nbsp;</td>
              <td>
                <span>Total:&nbsp;</span>
                <strong> {totalAmount? new Intl.NumberFormat(countryProperties.locale, { style: "currency", currency: countryProperties.currency_code }).format(totalAmount) : null}</strong>
              </td>
            </tr>
          </tfoot>
        </Table>

        
      </>
    );
  }
}

const mapStatetoProps = ({ buyOperatorState, selectOperatorState }) => {
  const selectedOperatorList = selectOperatorState.selectedOperators;
  const operatorTokensToBePurchased = buyOperatorState.operatorTokens;
  const operators = selectOperatorState.operators;

  const { units, amount, selectedRoutes } = operatorTokensToBePurchased || {};

  return {
    selectedOperatorList,
    operatorTokensToBePurchased,
    operators,
    units,
    amount,
    selectedRoutes,
  };
};

export default connect(mapStatetoProps)(PurchaseSummary);
